import { GraphQLError } from 'graphql'
import { ERROR_CODES } from '~/constants/errors'
import {
  getDimensionTranslation,
  getDefaultMeasureTranslation,
  getDimensionFromTitle,
  getMeasureFromTitle
} from '~/services/explore'

interface GqlError extends Error {
  graphQLErrors?: GraphQLError[]
}

export const getFormattedErrorParams = (
  error: Error,
  errorCode: ERROR_CODES
) => {
  if (
    [
      ERROR_CODES.ANALYTICS_INAPPLICABLE_FILTERS,
      ERROR_CODES.ANALYTICS_INAPPLICABLE_DIMENSIONS
    ].includes(errorCode)
  ) {
    return extractErrorParams(error as GqlError)
      .map(dimensionTitle => getDimensionFromTitle(dimensionTitle))
      .map(dimension => getDimensionTranslation(dimension))
      .join(', ')
  }

  if ([ERROR_CODES.ANALYTICS_INAPPLICABLE_MEASURES].includes(errorCode)) {
    return extractErrorParams(error)!
      .map(measureTitle => getMeasureFromTitle(measureTitle))
      .map(measure => getDefaultMeasureTranslation(measure!))
      .join(', ')
  }
  return null
}

export const extractErrorParams = (error: GqlError) => {
  return error.graphQLErrors![0]!.extensions.params as string[]
}
